const ManageOperationComponent = {
    templateUrl: '/configuration/manageOperation/manageOperation.tpl.html',
    controller: 'manageOperationController',
    bindings: {
        hasViewDetailHistoryPermission: '<',
        hasManageBackupRestorePermission: '<',
        hasManageImportDataPermission:'<',
        hasGenerateDataDictionaryPermission:'<'
    }
};

angular.module('ums.configuration')
    .component('uiManageOperation', ManageOperationComponent);

require('./manageOperation.i18n.json');
require('./manageOperation.tpl.html');
require('./manageOperationController.js');
require('./backup/backupModalController.js');
require('./detailedHistory/detailedHistoryModalController.js');
require('./restore/restoreModalController.js');
require('./importClassCodes/importClassCodesModalController.js');
require('./generateDataDictionary/generateDataDictionaryModalController.js');
